<template>
    <component v-bind:is="layout"></component>
</template>
<script>
import DesktopLayout from './layouts/DesktopLayout.vue';
import LoginLayout from './layouts/LoginLayout.vue';
import ForgotPassword from './layouts/ForgotPassword.vue';
export default {
  name: 'App',
  beforeMount: function() {},
  computed: {
    layout () {
      return this.$store.getters.getLayout
    }
  },
  components: {
    'login-layout': LoginLayout,
    'desktop-layout': DesktopLayout,
    'forgot-password': ForgotPassword
}
}
</script>



// WEBPACK FOOTER //
// src/App.vue